import React from 'react';
export function UploadIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M14.5 4a4.501 4.501 0 00-4.118 2.682l-.388.878-.894-.352a3 3 0 00-3.98 3.632l.28.96-.96.28A2.001 2.001 0 005 16h4v2H5a4 4 0 01-1.973-7.48 5 5 0 015.937-5.427 6.5 6.5 0 0111.928 4.595A4.5 4.5 0 0118.5 18H15v-2h3.5a2.5 2.5 0 00.875-4.843l-.9-.336.3-.913A4.5 4.5 0 0014.5 4z"
  }), React.createElement("path", {
    d: "M7.341 12.748l1.317 1.505 2.55-2.231L11 22h2l-.208-9.978 2.55 2.23 1.316-1.505L12 8.672l-4.659 4.077z"
  }));
}